// src/components/devices/SmartLockManager.js
import React, { useState, useContext, useEffect } from 'react';
import { AppContext } from '../../context/AppContext';
import SmartLockCard from './SmartLockCard';
import SmartLockDetails from './SmartLockDetails';
import './SmartLockManager.css';

/**
 * Component to manage smart locks
 */
const SmartLockManager = () => {
  const { 
    smartLocks, 
    refreshSmartLocks, 
    startSmartLockScan, 
    toggleSmartLock 
  } = useContext(AppContext);
  
  const [selectedLock, setSelectedLock] = useState(null);
  const [isScanning, setIsScanning] = useState(false);
  const [scanDuration, setScanDuration] = useState(15);
  
  // Refresh locks on mount
  useEffect(() => {
    refreshSmartLocks();
  }, [refreshSmartLocks]);
  
  // Handle toggle of a lock
  const handleToggleLock = async (mac, isLocked) => {
    await toggleSmartLock(mac, isLocked);
  };
  
  // Handle view details of a lock
  const handleViewDetails = (lock) => {
    setSelectedLock(lock);
  };
  
  // Handle close details
  const handleCloseDetails = () => {
    setSelectedLock(null);
    refreshSmartLocks();
  };
  
  // Handle scan for locks
  const handleScan = async () => {
    try {
      setIsScanning(true);
      await startSmartLockScan(scanDuration * 1000);
    } catch (error) {
      console.error('Error scanning for locks:', error);
    } finally {
      setIsScanning(false);
    }
  };
  
  return (
    <div className="smart-lock-manager">
      <h2>Smart Locks</h2>
      
      <div className="smart-lock-controls">
        <div className="scan-controls">
          <input 
            type="number" 
            min="5" 
            max="60" 
            value={scanDuration} 
            onChange={(e) => setScanDuration(parseInt(e.target.value))}
            disabled={isScanning}
          />
          <span className="duration-label">seconds</span>
          <button 
            className="scan-button" 
            onClick={handleScan}
            disabled={isScanning}
          >
            {isScanning ? 'Scanning...' : 'Scan for Locks'}
          </button>
        </div>
        
        <button 
          className="refresh-button" 
          onClick={refreshSmartLocks}
          disabled={isScanning}
        >
          Refresh Locks
        </button>
      </div>
      
      {smartLocks.length === 0 ? (
        <div className="no-locks-message">
          <p>No smart locks found. Click "Scan for Locks" to discover nearby locks.</p>
        </div>
      ) : (
        <div className="smart-lock-grid">
          {smartLocks.map(lock => (
            <SmartLockCard 
              key={lock.lockMac} 
              lock={lock} 
              onToggle={handleToggleLock}
              onDetails={handleViewDetails}
            />
          ))}
        </div>
      )}
      
      {selectedLock && (
        <SmartLockDetails 
          lock={selectedLock} 
          onClose={handleCloseDetails} 
        />
      )}
    </div>
  );
};

export default SmartLockManager;